import useAppStore from "@/context/store";
import { useEffect, useMemo } from "react";

/**
 * 返回尽量实时的用户采集数：max(user.pin_count, store.pinCount, remote pin_count)
 */
export function useRealtimePinCount() {
  const user = useAppStore((s) => s.user);
  const deltaPinCount = useAppStore((s) => s.deltaPinCount || 0);
  const basePinCount = useAppStore((s) =>
    Math.max(s.basePinCount || 0, s.user?.pin_count || 0)
  );
  const refreshRemotePinCountOnce = useAppStore(
    (s) => s.refreshRemotePinCountOnce
  );

  // 首屏/切换用户时按 TTL 限流刷新一次远端基础值
  useEffect(() => {
    refreshRemotePinCountOnce?.();
  }, [refreshRemotePinCountOnce, user?.urlname]);

  // 判定用“基线（远端/用户） + 本地会话增量”，不在悬停发请求
  return useMemo(() => {
    return (basePinCount || 0) + (deltaPinCount || 0);
  }, [basePinCount, deltaPinCount]);
}
